var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damages-details view" },
    [
      !_vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-category", {
                attrs: {
                  titleNavbar: _vm.titleNavBar,
                  qaName: "go-to-damagedParts-btn",
                  handleClickBack: _vm.handleClickPrevRoute,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-stepper", {
                attrs: {
                  numberOfStep: 2,
                  textOfStep: _vm.$t("Déclaration des dommages"),
                  handleClickBack: _vm.handleClickPrevRoute,
                  qaName: "go-to-damagedParts-btn",
                  arrowIsAllow: true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.flowName === "damage_billma_agent_new" || _vm.flowName === "e2e_new"
        ? _c("maDamagesCamera", {
            ref: "damagesCamera",
            staticClass: "save-button",
            on: { photosAdded: _vm.handleCameraPhotos },
          })
        : _vm._e(),
      _c("div", { staticClass: "view_content" }, [
        _c("div", { staticClass: "view_content_markdown" }, [
          _c("h1", [_vm._v(_vm._s(_vm.stateWarrantyDamagedItem))]),
          _vm.inputSurfaceData
            ? _c(
                "div",
                { staticClass: "container-input_surface" },
                [
                  _vm.inputSurfaceData
                    ? _c("ma-input-surface", {
                        ref: "inputSurfaceCommon",
                        attrs: {
                          type: "text",
                          name: _vm.inputSurfaceData.name,
                          col: "4",
                          icon: _vm.inputSurfaceData.icon,
                          literal: _vm.inputSurfaceData.literal,
                          value: _vm.inputSurfaceData.selectedValue,
                          disabled: _vm.inputSurfaceData.disabled,
                          inputError: _vm.$v.inputSurfaceValue.$error,
                        },
                        on: {
                          change: _vm.handleChangeInputSurface,
                          input: _vm.handleChangeInputSurface,
                        },
                        model: {
                          value: _vm.$v.inputSurfaceValue.$model,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.$v.inputSurfaceValue,
                              "$model",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "$v.inputSurfaceValue.$model",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "container-hint" },
                    [
                      _c("svgicon", {
                        staticClass: "mg mg--r-1",
                        attrs: {
                          name: "Info",
                          height: "12",
                          widht: "12",
                          color: "#5F646C",
                        },
                      }),
                      _c("p", { staticClass: "text-small gray" }, [
                        _vm._v(
                          _vm._s(_vm.$t("damageDetails.surfaceSmallText"))
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.flowName !== "damage_billma_agent_new" &&
          _vm.flowName !== "e2e_new"
            ? _c(
                "ul",
                { staticClass: "listForms" },
                _vm._l(_vm.dataForms, function (form) {
                  return _c(
                    "li",
                    { staticClass: "mg mg--t-4 mg--b-2" },
                    [
                      _c("ma-form", {
                        ref: "form",
                        refInFor: true,
                        attrs: {
                          categoryTitle: form.damagedPart.damagedPart,
                          categoryLiteral: form.damagedPart.literal,
                          type: "large",
                          formData: form.form,
                          showDropDown: _vm.dataForms.length > 1,
                          titleFileInputEnsemble: _vm.$t(
                            "damagesConfirmed.photosEnsemble"
                          ),
                          nameFileInputEnsemble: "inputImgEnsemble",
                          titleFileInputPres: _vm.$t(
                            "damagesConfirmed.photosPres"
                          ),
                          nameFileInputPres: "inputImgPres",
                          inputImgListEnsemble: _vm.imageCategoryEnsemble(
                            form.damagedPart.damagedPart
                          ),
                          inputImgListPres: _vm.imageCategoryPres(
                            form.damagedPart.damagedPart
                          ),
                          showSpinner: _vm.spinner,
                        },
                        on: {
                          change: function ($event) {
                            _vm.handleFormChange($event)
                            _vm.handleNestedComponents($event)
                          },
                          "file:change-ensemble": _vm.handleFileChangeEnsemble,
                          "file:change-pres": _vm.handleFileChangePres,
                        },
                        nativeOn: {
                          focus: function ($event) {
                            return _vm.handleInputFocus()
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.flowName === "damage_billma_agent_new" ||
          _vm.flowName === "e2e_new"
            ? _c(
                "ul",
                { staticClass: "listForms" },
                _vm._l(_vm.dataForms, function (form) {
                  return _c(
                    "li",
                    { staticClass: "mg mg--t-4 mg--b-2" },
                    [
                      _c("ma-form", {
                        ref: "form",
                        refInFor: true,
                        attrs: {
                          categoryTitle: form.damagedPart.damagedPart,
                          categoryLiteral: form.damagedPart.literal,
                          type: "large",
                          formData: form.form,
                          showDropDown: _vm.dataForms.length > 1,
                          hasUploadImgs: false,
                          showSpinner: _vm.spinner,
                        },
                        on: {
                          change: function ($event) {
                            _vm.handleFormChange($event)
                            _vm.handleNestedComponents($event)
                          },
                        },
                        nativeOn: {
                          focus: function ($event) {
                            return _vm.handleInputFocus()
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "container-btn-add-element-camera" },
                        [
                          _vm.imgListNewCamera &&
                          _vm.imgListNewCamera.length &&
                          _vm.imgListNewCamera.length === 0 &&
                          !_vm.imgNoRequired
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.handleOnShowModalCamera },
                                },
                                [
                                  _c("svgicon", {
                                    attrs: {
                                      name: "camera-create",
                                      color: "#005BA5",
                                      height: "15",
                                      width: "auto",
                                    },
                                  }),
                                  _c("p", { staticClass: "text-medium" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "multidamageList.cameraFlow.cameraBtn2"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.imgNoRequired
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn buttonLink mg mg--b-4",
                                  on: { click: _vm.handleNoRequirePhotos },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-medium black" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "multidamageList.cameraFlow.noRequired"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      (_vm.flowName === "damage_billma_agent_new" &&
                        _vm.imgListNewCamera &&
                        _vm.imgListNewCamera.length > 0) ||
                      (_vm.flowName === "e2e_new" &&
                        _vm.imgListNewCamera.length > 0)
                        ? _c(
                            "div",
                            { staticClass: "list-damage-images mg mg--t-4" },
                            [
                              _c("div", { staticClass: "p text-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("damageDetails.titleFileInputPres")
                                  )
                                ),
                                _c("div", { staticClass: "camera__damages" }, [
                                  _c(
                                    "div",
                                    { staticClass: "damage__photos" },
                                    _vm._l(
                                      _vm.imgListNewCamera,
                                      function (image) {
                                        return _c(
                                          "figure",
                                          { staticClass: "damage-img" },
                                          [
                                            _c("img", {
                                              attrs: { src: image.imageURL },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c("update-damages-btn", {
            attrs: {
              handleButtonClick: _vm.handleSendDamages,
              title: _vm.$t("multidamageList.btnAddDamageModal"),
              btnType: _vm.getBtnType,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }